// extracted by mini-css-extract-plugin
export default {"NoPage":"NoPage_NoPage__t5zrB"};